import React from 'react';
import PropTypes from 'prop-types';

import DbEditContainer from './db/DbEditContainer';
import DbListContainer from './db/DbListContainer';
import UST3R from './page/UST3R';
import UST4 from './page/UST4';
import Scheduler from './scheduler/Scheduler';
import PairTerminalPage from './payment/PairTerminalPage';
import DealExplorer from './crm/DealExplorer';
import JumpToDeal from './crm/JumpToDeal';
import EquipmentInventory from './crm/EquipmentInventory';
import EquipmentSettings from './crm/EquipmentSettings';
import PaymentSessionDetail from './payment/PaymentSessionDetail';

const Db = ({ page, name, itemId = '', query = {}, action = '' }) => {
  if (name === 'UST3R') {
    if (action === 'edit') {
      return <UST3R userId={parseInt(itemId)} />;
    }

    return (
      <DbListContainer
        name={name}
        modelName={page.ModelName}
        canAdd={false}
        canDelete={false}
        canCopy={false}
        idFieldName={['userId', 'branchId']}
        query={query.q}
      />
    );
  }

  const showRowToolbar = page.HideRowToolbar !== true;

  if (name === 'UPY2' && ['new'].includes(action)) {
    return <PairTerminalPage />;
  }

  if (name === 'UST4' && ['edit', 'new', 'copy'].includes(action)) {
    return <UST4 itemId={itemId} itemName={name} action={action} />;
  }

  if (name === 'YMS11' && ['edit', 'new', 'copy'].includes(action)) {
    return <Scheduler id={itemId} action={action} />;
  }

  if (name === 'EQS2' && ['edit'].includes(action)) {
    return <DealExplorer dealId={parseInt(itemId)} query={query} />;
  }

  if (name === 'EQS1' && ['edit'].includes(action)) {
    return <JumpToDeal quoteId={parseInt(itemId)} />;
  }

  if (name === 'EQS7') {
    return <EquipmentInventory />;
  }

  if (name === 'EQS8') {
    return <EquipmentSettings />;
  }

  if (action === 'edit' || action === 'new' || action === 'copy') {
    return (
      <DbEditContainer
        namespace="db"
        itemName={name}
        itemId={itemId}
        action={action}
        page={page}
        showRowToolbar={showRowToolbar}
        query={query}
      />
    );
  }

  if (name === 'UPY4' && itemId) {
    return <PaymentSessionDetail id={itemId} />;
  }

  if (name === 'UPY3' && itemId) {
    return <PaymentSessionDetail cardTransactionId={itemId} />;
  }

  const validTypes = page.ValidTypes || ['add', 'update', 'copy', 'delete'];

  return (
    <DbListContainer
      name={name}
      modelName={page.ModelName}
      canAdd={validTypes.includes('add')}
      canCopy={validTypes.includes('copy')}
      canDelete={validTypes.includes('delete')}
      canEdit={validTypes.includes('update')}
      canRead={validTypes.includes('read')}
      canUpload={validTypes.includes('upload')}
      canNotes={validTypes.includes('notes')}
      idFieldName={page.IdFieldName || 'id'}
      showRowToolbar={showRowToolbar}
      query={query.q}
    />
  );
};

Db.propTypes = {
  action: PropTypes.string,
  itemId: PropTypes.string,
  name: PropTypes.string,
  page: PropTypes.object,
  query: PropTypes.object,
};

export default Db;
